const ServerData = {
    'uri':'https://shotpe.in/apiconnect'
}

export default ServerData